export const epicRadio = [
  { text: 'Brain-Blood', value: 'Brain-Blood' },
  { text: 'Brain-Saliva', value: 'Brain-Saliva' },
  { text: 'Brain-Buccal', value: 'Brain-Buccal' },
  { text: 'Blood-Saliva', value: 'Blood-Saliva' },
  { text: 'Blood-Buccal', value: 'Blood-Buccal' },
  { text: 'Saliva-Buccal', value: 'Saliva-Buccal' },
  {
    text: 'Brain-Blood-Saliva-Buccal',
    value: 'Brain-Blood-Saliva-Buccal'
  }
]

export const constantHeader = [
  { text: 'cgid', value: 'cgid' },
  { text: 'chr', value: 'chr' },
  { text: 'MAPINFO', value: 'MAPINFO' }
]

export const methyColumn = [
  { text: 'brain_mean', category: 'Brain', value: 'brain_mean' },
  { text: 'brain_sd', category: 'Brain', value: 'brain_sd' },
  { text: 'blood_mean', category: 'Blood', value: 'blood_mean' },
  { text: 'blood_sd', category: 'Blood', value: 'blood_sd' },
  { text: 'saliva_mean', category: 'Saliva', value: 'saliva_mean' },
  { text: 'saliva_sd', category: 'Saliva', value: 'saliva_sd' },
  { text: 'buccal_mean', category: 'Buccal', value: 'buccal_mean' },
  { text: 'buccal_sd', category: 'Buccal', value: 'buccal_sd' },
  {
    text: 'rho_brain_blood',
    category: 'Brain-Blood',
    value: 'rho_brain_blood'
  },
  {
    text: 'p_rho_brain_blood',
    category: 'Brain-Blood',
    value: 'p_rho_brain_blood'
  },
  {
    text: 'rho_brain_saliva',
    category: 'Brain-Saliva',
    value: 'rho_brain_saliva'
  },
  {
    text: 'p_rho_brain_saliva',
    category: 'Brain-Saliva',
    value: 'p_rho_brain_saliva'
  },
  {
    text: 'rho_brain_buccal',
    category: 'Brain-Buccal',
    value: 'rho_brain_buccal'
  },
  {
    text: 'p_rho_brain_buccal',
    category: 'Brain-Buccal',
    value: 'p_rho_brain_buccal'
  },
  {
    text: 'rho_blood_saliva',
    category: 'Blood-Saliva',
    value: 'rho_blood_saliva'
  },
  {
    text: 'p_rho_blood_saliva',
    category: 'Blood-Saliva',
    value: 'p_rho_blood_saliva'
  },
  {
    text: 'rho_blood_buccal',
    category: 'Blood-Buccal',
    value: 'rho_blood_buccal'
  },
  {
    text: 'p_rho_blood_buccal',
    category: 'Blood-Buccal',
    value: 'p_rho_blood_buccal'
  },
  {
    text: 'rho_saliva_buccal',
    category: 'Saliva-Buccal',
    value: 'rho_saliva_buccal'
  },
  {
    text: 'p_rho_saliva_buccal',
    category: 'Saliva-Buccal',
    value: 'p_rho_saliva_buccal'
  },
  {
    text: 'brain_mean_adj',
    category: 'Brain',
    value: 'brain_mean_adj'
  },
  {
    text: 'brain_sd_adj',
    category: 'Brain',
    value: 'brain_sd_adj'
  },
  {
    text: 'blood_mean_adj',
    category: 'Blood',
    value: 'blood_mean_adj'
  },
  {
    text: 'blood_sd_adj',
    category: 'Blood',
    value: 'blood_sd_adj'
  },
  {
    text: 'saliva_mean_adj',
    category: 'Saliva',
    value: 'saliva_mean_adj'
  },
  {
    text: 'saliva_sd_adj',
    category: 'Saliva',
    value: 'saliva_sd_adj'
  },
  {
    text: 'buccal_mean_adj',
    category: 'Buccal',
    value: 'buccal_mean_adj'
  },
  {
    text: 'buccal_sd_adj',
    category: 'Buccal',
    value: 'buccal_sd_adj'
  },
  {
    text: 'rho_brain_blood_adj',
    category: 'Brain-Blood',
    value: 'rho_brain_blood_adj'
  },
  {
    text: 'p_rho_brain_blood_adj',
    category: 'Brain-Blood',
    value: 'p_rho_brain_blood_adj'
  },
  {
    text: 'rho_brain_saliva_adj',
    category: 'Brain-Saliva',
    value: 'rho_brain_saliva_adj'
  },
  {
    text: 'p_rho_brain_saliva_adj',
    category: 'Brain-Saliva',
    value: 'p_rho_brain_saliva_adj'
  },
  {
    text: 'rho_brain_buccal_adj',
    category: 'Brain-Buccal',
    value: 'rho_brain_buccal_adj'
  },
  {
    text: 'p_rho_brain_buccal_adj',
    category: 'Brain-Buccal',
    value: 'p_rho_brain_buccal_adj'
  },
  {
    text: 'rho_blood_saliva_adj',
    category: 'Blood-Saliva',
    value: 'rho_blood_saliva_adj'
  },
  {
    text: 'p_rho_blood_saliva_adj',
    category: 'Blood-Saliva',
    value: 'p_rho_blood_saliva_adj'
  },
  {
    text: 'rho_blood_buccal_adj',
    category: 'Blood-Buccal',
    value: 'rho_blood_buccal_adj'
  },
  {
    text: 'p_rho_blood_buccal_adj',
    category: 'Blood-Buccal',
    value: 'p_rho_blood_buccal_adj'
  },
  {
    text: 'rho_saliva_buccal_adj',
    category: 'Saliva-Buccal',
    value: 'rho_saliva_buccal_adj'
  },
  {
    text: 'p_rho_saliva_buccal_adj',
    category: 'Saliva-Buccal',
    value: 'p_rho_saliva_buccal_adj'
  },
  {
    text: '#clusters_BL',
    category: 'Brain-Blood',
    value: '#clusters_BL'
  },
  {
    text: 'betweenss2_BL',
    category: 'Brain-Blood',
    value: 'betweenss2_BL'
  },
  {
    text: 'betweenss3_BL',
    category: 'Brain-Blood',
    value: 'betweenss3_BL'
  },
  {
    text: 'betweenss_BL',
    category: 'Brain-Blood',
    value: 'betweenss_BL'
  },
  {
    text: 'SNP_BL',
    category: 'Brain-Blood',
    value: 'SNP_BL'
  },
  {
    text: '#clusters_SA',
    category: 'Brain-Saliva',
    value: '#clusters_SA'
  },
  {
    text: 'betweenss2_SA',
    category: 'Brain-Saliva',
    value: 'betweenss2_SA'
  },
  {
    text: 'betweenss3_SA',
    category: 'Brain-Saliva',
    value: 'betweenss3_SA'
  },
  {
    text: 'betweenss_SA',
    category: 'Brain-Saliva',
    value: 'betweenss_SA'
  },
  {
    text: 'SNP_SA',
    category: 'Brain-Saliva',
    value: 'SNP_SA'
  },
  {
    text: '#clusters_EP',
    category: 'Brain-Buccal',
    value: '#clusters_EP'
  },
  {
    text: 'betweenss2_EP',
    category: 'Brain-Buccal',
    value: 'betweenss2_EP'
  },
  {
    text: 'betweenss3_EP',
    category: 'Brain-Buccal',
    value: 'betweenss3_EP'
  },
  {
    text: 'betweenss_EP',
    category: 'Brain-Buccal',
    value: 'betweenss_EP'
  },
  {
    text: 'SNP_EP',
    category: 'Brain-Buccal',
    value: 'SNP_EP'
  },
  {
    text: 'SNP_flag',
    category: 'Brain-Blood-Saliva-Buccal',
    value: 'SNP_flag'
  },
  {
    text: 'mQTL_flag',
    category: 'Brain-Blood-Saliva-Buccal',
    value: 'mQTL_flag'
  },
  {
    text: 'varBR_flag',
    category: 'Brain',
    value: 'varBR_flag'
  },
  {
    text: 'varBL_flag',
    category: 'Blood',
    value: 'varBL_flag'
  },
  {
    text: 'varSA_flag',
    category: 'Saliva',
    value: 'varSA_flag'
  },
  {
    text: 'varEP_flag',
    category: 'Buccal',
    value: 'varEP_flag'
  },
  {
    text: 'varBRadj_flag',
    category: 'Brain',
    value: 'varBRadj_flag'
  },
  {
    text: 'varBLadj_flag',
    category: 'Blood',
    value: 'varBLadj_flag'
  },
  {
    text: 'varSAadj_flag',
    category: 'Saliva',
    value: 'varSAadj_flag'
  },
  {
    text: 'varEPadj_flag',
    category: 'Buccal',
    value: 'varEPadj_flag'
  },
  {
    text: 'BL_A-I0.2_flag',
    category: 'Brain-Blood',
    value: 'BL_A-I0.2_flag'
  },
  {
    text: 'SA_A-I0.2_flag',
    category: 'Brain-Saliva',
    value: 'SA_A-I0.2_flag'
  },
  {
    text: 'EP_A-I0.2_flag',
    category: 'Brain-Buccal',
    value: 'EP_A-I0.2_flag'
  },
  {
    text: 'BLadj_A-I0.2_flag',
    category: 'Brain-Blood',
    value: 'BLadj_A-I0.2_flag'
  },
  {
    text: 'SAadj_A-I0.2_flag',
    category: 'Brain-Saliva',
    value: 'SAadj_A-I0.2_flag'
  },
  {
    text: 'EPadj_A-I0.2_flag',
    category: 'Brain-Buccal',
    value: 'EPadj_A-I0.2_flag'
  }
]

export const flagKey = [
  'SNP_flag',
  'mQTL_flag',
  'varBR_flag',
  'varBL_flag',
  'varSA_flag',
  'varEP_flag',
  'varBRadj_flag',
  'varBLadj_flag',
  'varSAadj_flag',
  'varEPadj_flag',
  'BL_A-I0.2_flag',
  'SA_A-I0.2_flag',
  'EP_A-I0.2_flag',
  'BLadj_A-I0.2_flag',
  'SAadj_A-I0.2_flag',
  'EPadj_A-I0.2_flag'
]
